/**
 * Date/time formatting utilities
 * Based on https://stackoverflow.com/a/24314927
 */

declare const moment: any;

const shortMonths = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const fullMonths = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

const shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const fullDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function formatDateString(date: Date, format: string): string {
    const yyyy = date.getFullYear();
    const M = date.getMonth();
    const d = date.getDate();
    const day = date.getDay();
    const H = date.getHours();
    let h = H;
    const pm = h > 12;
    if (pm) h = H - 12;
    const m = date.getMinutes();
    const s = date.getSeconds();
    const f = date.getMilliseconds();

    format = format
        .replace(/GMT/g, '*00*')
        .replace(/yyyy/g, '*01*')
        .replace(/yyy/g, '*02*')
        .replace(/yy/g, '*03*')
        .replace(/y/g, '*04*')
        .replace(/MMMM/g, '*05*')
        .replace(/MMM/g, '*06*')
        .replace(/MM/g, '*07*')
        .replace(/M/g, '*08*')
        .replace(/dddd/g, '*09*')
        .replace(/ddd/g, '*10*')
        .replace(/dd/g, '*11*')
        .replace(/d/g, '*12*')
        .replace(/HH/g, '*13*')
        .replace(/H/g, '*14*')
        .replace(/hh/g, '*15*')
        .replace(/h/g, '*16*')
        .replace(/mm/g, '*17*')
        .replace(/m/g, '*18*')
        .replace(/ss/g, '*19*')
        .replace(/s/g, '*20*')
        .replace(/fff/g, '*21*')
        .replace(/ff/g, '*22*')
        .replace(/f/g, '*23*')
        .replace(/FFF/g, '*24*')
        .replace(/FF/g, '*25*')
        .replace(/F/g, '*26*')
        .replace(/tt/g, pm ? 'PM' : 'AM')
        .replace(/t/g, pm ? 'P' : 'A')
        .replace('*00*', 'GMT')
        .replace('*01*', String(yyyy))
        .replace('*02*', String(yyyy).substr(-3, 3))
        .replace('*03*', String(yyyy).substr(-2, 2))
        .replace('*04*', String(yyyy).substr(-1, 1))
        .replace('*05*', getFullMonth(String(M)))
        .replace('*06*', getShortMonth(String(M)))
        .replace('*07*', padZeroes(String(M), 2))
        .replace('*08*', String(M))
        .replace('*09*', getFullDay(String(day)))
        .replace('*10*', getShortDay(String(day)))
        .replace('*11*', padZeroes(String(d), 2))
        .replace('*12*', String(d))
        .replace('*13*', padZeroes(String(H), 2))
        .replace('*14*', String(H))
        .replace('*15*', padZeroes(String(h), 2))
        .replace('*16*', String(h))
        .replace('*17*', padZeroes(String(m), 2))
        .replace('*18*', String(m))
        .replace('*19*', padZeroes(String(s), 2))
        .replace('*20*', String(s))
        .replace('*21*', padZeroes(String(f), 3))
        .replace('*22*', padZeroes(String(Math.round(f / 10)), 2))
        .replace('*23*', String(Math.round(f / 100)))
        .replace('*24*', blankZero(padZeroes(String(f), 3)))
        .replace('*25*', blankZero(padZeroes(String(Math.round(f / 10)), 2)))
        .replace('*26*', blankZero(String(Math.round(f / 100))));

    return format;
}

function getShortMonth(month: string): string {
    return shortMonths[parseInt(month, 10)];
}

function getFullMonth(month: string): string {
    return fullMonths[parseInt(month, 10)];
}

function getShortDay(day: string): string {
    return shortDays[parseInt(day, 10)];
}

function getFullDay(day: string): string {
    return fullDays[parseInt(day, 10)];
}

function padZeroes(toPad: string, numDigits: number): string {
    toPad = toPad || '';
    const zeroes = Array(numDigits).join('0');
    return (zeroes + toPad).substr(-numDigits, numDigits);
}

function blankZero(number: string): string {
    const n = parseFloat(number);
    if (isNaN(n)) return '';
    if (n == 0.0) return '';
    return String(n);
}

export const DateTimes = {
    defaultDateFormat: 'M/D/YYYY h:mm:ss A',
    formatDateString: formatDateString,
    stringDateToMoment: function (str: string): any {
        return (window as any).moment(str, DateTimes.defaultDateFormat);
    },
    stringDateToDate: function (str: string): Date {
        return this.stringDateToMoment(str).toDate();
    }
};

// Make available globally
(window as any).DateTimes = DateTimes;
